import { action } from 'typesafe-actions'

import {
  ItemPriceHistory,
  ItemPriceHistoryPagination,
  ItemPriceHistoryParam,
} from './item-price-histories'

export enum itemPriceHistoryActionType {
  FETCH_ITEM_PRICE_HISTORIES = 'ITEM_PRICE_HISTORY/FETCH_ITEM_PRICE_HISTORIES',
  FETCH_ITEM_PRICE_HISTORIES_SUCCEEDED = 'ITEM_PRICE_HISTORY/FETCH_ITEM_PRICE_HISTORIES_SUCCEEDED',
  THROW_ERROR = 'ITEM_PRICE_HISTORY/THROW_ERROR',
}

export const itemPriceHistoryActions = {
  fetchItemPriceHistories: (param: ItemPriceHistoryParam) =>
    action(itemPriceHistoryActionType.FETCH_ITEM_PRICE_HISTORIES, param),
  fetchItemPriceHistoriesSucceeded: (
    histories: ItemPriceHistory[],
    pagination: ItemPriceHistoryPagination
  ) =>
    action(itemPriceHistoryActionType.FETCH_ITEM_PRICE_HISTORIES_SUCCEEDED, {
      histories,
      pagination,
    }),
  throwError: (error: Error) =>
    action(itemPriceHistoryActionType.THROW_ERROR, { error }),
}
